import { getFundraiser, getLeaderboard } from 'actions/app'
import { FundraiserCard } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, Col, Container, FormControl, Row, Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

const REFRESH_INTERVAL = 60 * 1000 // every minute

export function Leaderboard({ fundraiser, getFundraiser, getLeaderboard }) {
  const [loading, setLoading] = React.useState(true)
  const [leaders, setLeaders] = React.useState([])
  const [refreshRate, setRefreshRate] = React.useState(REFRESH_INTERVAL)
  const { shortcode } = useParams()

  const tiedPositions = React.useMemo(() => {
    const seen = new Set()
    const ties = new Set()
    leaders.forEach(({ position }) => {
      if (seen.has(position)) {
        ties.add(position)
      }
      seen.add(position)
    })
    return Array.from(ties)
  }, [leaders])

  console.log('Refresh rate:', refreshRate)

  React.useEffect(() => {
    const load = async () => {
      try {
        getFundraiser(shortcode)
        const data = await getLeaderboard() // refresh leaderboard
        setLeaders(data)
        setLoading(false)
      } catch (err) {
        console.error('error loading leaderboard')
        console.error(err)
      }
    }

    load()
    const interval = setInterval(load, refreshRate)
    return () => clearInterval(interval)
  }, [getFundraiser, getLeaderboard, shortcode, refreshRate])

  const handleRefreshRate = (event) => {
    setRefreshRate(event.target.value)
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1 className='text-center mt-3 mt-lg-5'>Leaderboard</h1>
        </Col>
      </Row>
      <Row className='my-3 my-lg-5'>
        <Col md={9} lg={5} className='mx-auto mb-3'>
          <FundraiserCard fundraiser={fundraiser} />
          <p className='small text-muted p-2 form-inline justify-content-end'>
            This page refreshes every{' '}
            <FormControl
              as='select'
              size='sm'
              className='mx-1'
              custom
              onChange={handleRefreshRate}
            >
              <option value={60 * 1000}>60</option>
              <option value={30 * 1000}>30</option>
              <option value={15 * 1000}>15</option>
            </FormControl>{' '}
            seconds
          </p>
        </Col>
        <Col md={9} lg={7} className='mx-auto mb-3'>
          <Card>
            <Card.Body className='p-0'>
              <Table
                responsive
                borderless
                striped
                className='text-center leaderboard-table mb-0'
              >
                <thead>
                  <tr className='heavyset text-secondary'>
                    <th></th>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Sales</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={4} className='text-center py-5'>
                        Loading
                        <i className='fas fa-spinner fa-spin ml-1' />
                      </td>
                    </tr>
                  ) : leaders.length === 0 ? (
                    <tr>
                      <td colSpan={4} className='text-center py-5'>
                        Be the first on the leaderboard!
                      </td>
                    </tr>
                  ) : (
                    <>
                      {leaders.map((leader) => (
                        <tr
                          key={`${leader.first_name} ${leader.last_name}`}
                          className='heavyset'
                        >
                          <td>
                            {leader.position === 1 && (
                              <i className='fad fa-trophy-alt first-place fa-2x' />
                            )}
                            {leader.position === 2 && (
                              <i className='fad fa-trophy second-place fa-lg' />
                            )}
                            {leader.position === 3 && (
                              <i className='fad fa-trophy third-place fa-lg' />
                            )}
                          </td>
                          <td>
                            {tiedPositions.includes(leader.position) && 'T'}
                            {leader.position}
                          </td>
                          <td>
                            {leader.first_name} {leader.last_name}
                          </td>
                          <td>{leader.quantity}</td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

Leaderboard.propTypes = {
  fundraiser: PropTypes.object.isRequired,
  getFundraiser: PropTypes.func.isRequired,
  getLeaderboard: PropTypes.func.isRequired,
}

const mapState = (state) => ({
  fundraiser: state.fundraiser,
})

const mapDispatch = {
  getFundraiser,
  getLeaderboard,
}

export default connect(mapState, mapDispatch)(Leaderboard)
